import { z } from 'zod';
/** Stati della giornata di lega (macchina a stati, lineeguida §29). */
export const leagueMatchdayStates = [
    'DRAFT',
    'SCHEDULED',
    'OPEN',
    'CLOSED',
    'RESULTS_PENDING',
    'RESULTS_VERIFIED',
    'SCORING',
    'PUBLISHED',
];
/** Transizioni valide: da stato → stati raggiungibili. */
export const VALID_TRANSITIONS = {
    DRAFT: ['SCHEDULED'],
    SCHEDULED: ['OPEN', 'DRAFT'],
    OPEN: ['CLOSED'],
    // Riapertura d'emergenza (chiusura per errore): consentita finché i
    // punteggi non sono stati calcolati e le partite non sono iniziate.
    CLOSED: ['RESULTS_PENDING', 'OPEN'],
    RESULTS_PENDING: ['RESULTS_VERIFIED', 'OPEN'],
    RESULTS_VERIFIED: ['SCORING'],
    SCORING: ['PUBLISHED', 'RESULTS_VERIFIED'], // ritorno se il calcolo va rifatto
    PUBLISHED: ['SCORING'], // ricalcolo post-correzione (con audit)
};
export const createLeagueMatchdaySchema = z.object({
    seasonMatchdayId: z.string().min(1, 'Seleziona una giornata del campionato'),
    /** Chiusura pronostici (ISO). Obbligatoria per aprire la giornata. */
    deadline: z.string().datetime().optional(),
    opensAt: z.string().datetime().optional(),
});
export const updateLeagueMatchdaySchema = z.object({
    deadline: z.string().datetime().optional(),
    opensAt: z.string().datetime().nullable().optional(),
});
export const transitionSchema = z.object({
    to: z.enum(leagueMatchdayStates),
});
//# sourceMappingURL=matchday.js.map